import { Component, OnDestroy, signal, effect, ViewChildren, QueryList, ElementRef, inject, computed } from '@angular/core';
import { MediaType, PlatformType } from '../../../enum/app.enum';
import { AppService } from '../../../services/app.service';
import { TranslatePipe } from '@codeandweb/ngx-translate';
import { Button } from 'primeng/button';
import { mainSlideList } from '../../../lists/main-slide-list';
import { MainSlide } from '../../../interfaces/app.interface';

@Component({
  selector: 'app-custom-slide',
  imports: [TranslatePipe, Button],
  templateUrl: './custom-slide.html',
  styleUrl: './custom-slide.scss'
})
export class CustomSlide implements OnDestroy {
  @ViewChildren('bannerVideo') bannerVideo!: QueryList<ElementRef<HTMLVideoElement>>;
  public appService = inject(AppService);
  public index = signal(0);
  public animated = signal(false);
  public progressPercent = computed(() => {
    const current = this.index() + 1;
    const total = this.mainSlideList.length || 1;
    return (current / total) * 100;
  });
  protected readonly MediaType = MediaType;
  protected readonly PlatformType = PlatformType;
  private timerId: number | null = null;

  constructor() {
    effect(() => {
      const index = this.index();
      const item = this.mainSlideList[index];
      this.clearTimer();
      if (!item) return;

      if (item.type === MediaType.Image) {
        this.pauseAllVideos();
        this.timerId = window.setTimeout(() => this.next(), 10_000);
      } else {
        queueMicrotask(() => {
          this.bannerVideo?.forEach((videoRef, i) => {
            const video = videoRef.nativeElement;

            const source = video.querySelector('source');
            const src = source?.getAttribute('src') || '';
            if (src === item.src) {
              video.currentTime = 0;
              video.play().catch(() => {});
            } else {
              video.pause();
              video.currentTime = 0;
            }
          });
        });
      }
    });
  }

  get mainSlideList(): MainSlide[] {
    const slideList = mainSlideList.find(slide => slide.language === this.appService.usedLanguage());
    if (slideList) {
      return slideList.list;
    }
    return [];
  }

  ngOnDestroy() {
    this.clearTimer();
    this.pauseAllVideos();
  }

  prev() {
    const len = this.mainSlideList.length;
    this.index.set((this.index() - 1 + len) % len);
  }

  next() {
    setTimeout(() => {
      const len = this.mainSlideList.length;
      this.index.set((this.index() + 1) % len);
    }, 100);
  }

  markLoaded(i: number) {
    if (i === 0 && !this.animated()) {
      requestAnimationFrame(() => this.animated.set(true));
    }
  }

  pauseAllVideos() {
    this.bannerVideo?.forEach(ref => {
      try {
        ref.nativeElement.pause();
      } catch {}
    });
  }

  clearTimer() {
    if (this.timerId !== null) {
      clearTimeout(this.timerId);
      this.timerId = null;
    }
  }

  handleVideoEnded(i: number) {
    if (i === this.index()) this.next();
  }

  goToService(site: string) {
    window.open(site, '_blank');
  }
}
